// Password / Regex validation.
// Moved from js/global.ts (originally js/Password_Regex.js). global.ts re-exports
// these for back-compat with existing importers and its own tests.

export const PASSWORD_ERROR_MESSAGES = {
  EMPTY: "Please enter a password.",
  MINLENGTH:
    "Password should be at least 8 characters, including upper and lower case letters, numbers, and special characters.",
  LCASE: "Password must contain at least one lowercase letter.",
  UCASE: "Password must contain at least one uppercase letter.",
  DIGIT: "Password must contain at least one digit.",
  SPECIAL: "Password must contain at least one special character",
  SPACES: "Password cannot contain spaces.",
}

export interface ValidationResult {
  valid: boolean
  errors: string[]
}

export function validatePass(passwordString: string): ValidationResult {
  const errors: string[] = []

  if (passwordString === "") {
    errors.push(PASSWORD_ERROR_MESSAGES.EMPTY)
    return { valid: false, errors }
  }

  if (passwordString.length < 8) {
    errors.push(PASSWORD_ERROR_MESSAGES.MINLENGTH)
  }
  if (!/[a-z]/.test(passwordString)) {
    errors.push(PASSWORD_ERROR_MESSAGES.LCASE)
  }
  if (!/[A-Z]/.test(passwordString)) {
    errors.push(PASSWORD_ERROR_MESSAGES.UCASE)
  }
  if (!/\d/.test(passwordString)) {
    errors.push(PASSWORD_ERROR_MESSAGES.DIGIT)
  }
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(passwordString)) {
    errors.push(PASSWORD_ERROR_MESSAGES.SPECIAL)
  }
  if (/\s/.test(passwordString)) {
    errors.push(PASSWORD_ERROR_MESSAGES.SPACES)
  }

  return { valid: errors.length === 0, errors }
}
